if (!customElements.get('store-inventory')) {
  class StoreInventory extends HTMLElement {
    constructor() {
      super();
      // Init straight away (no lazy init): the variant listener must be
      // active even before the element is scrolled into view, otherwise
      // stock counts can be stale after an early variant change.
      this.init();
    }

    init() {
      if (this.initialized) return;
      this.initialized = true;

      this.storeValueEl = this.querySelector('.js-store-inventory-store');
      this.webValueEl = this.querySelector('.js-store-inventory-web');
      this.orderNoteEl = this.querySelector('.js-store-inventory-order-note');
      this.threshold = parseInt(this.dataset.threshold, 10) || 9;

      const dataEl = this.querySelector('[type="application/json"]');
      this.variantData = JSON.parse(dataEl.textContent);

      // Follow the theme pattern: listen for variant changes
      const productInfo = this.closest('.product-info');
      const variantPicker = productInfo ? productInfo.querySelector('variant-picker') : null;
      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }

      this.update(parseInt(this.dataset.currentVariantId, 10));
    }

    handleVariantChange(evt) {
      this.update(evt.detail.variant ? evt.detail.variant.id : null);
    }

    format(count) {
      if (count <= 0) return this.dataset.textNone;
      if (count > this.threshold) return this.dataset.textOver;
      return this.dataset.textCount.replace('[quantity]', count);
    }

    update(variantId) {
      const data = variantId ? this.variantData.find((v) => v.id === variantId) : null;

      if (!data || !data.tracked) {
        this.hidden = true;
        return;
      }

      this.hidden = false;
      this.storeValueEl.textContent = this.format(data.store);
      this.webValueEl.textContent = this.format(data.total);

      if (this.orderNoteEl) {
        this.orderNoteEl.hidden = !(data.store <= 0 && data.total >= 1);
      }
    }
  }

  customElements.define('store-inventory', StoreInventory);
}
